import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import NextIcon from "../../Icons/Timeline/TimelineNext.svg";
import { useAppContext } from "../../../_context";
import { Fragment } from "react";
import Image from "next/image";

const TimelineSectionContent = ({ data, nEmployees }) => {
  const [{ tx }] = useAppContext();

  // const nEmp = nEmployees
  const nEmp = 5;
  return (
    <Timeline>
      <TimelineItem>
        <TimelineOppositeContent className="d-none d-md-flex" />
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent />
      </TimelineItem>

      {data.map((item, index) => {
        return (
          <Fragment key={index}>
            <TimelineItem>
              <TimelineOppositeContent className="timeline-year fw-bolder d-none d-md-flex">
                <div className="w-100 text-end">{item.date}</div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <div className="h-100 d-flex align-items-center">
                  <Image
                    src={item.icon}
                    width={80}
                    height={80}
                    unoptimized={true}
                  />
                </div>
                {/*<TimelineConnector />*/}
              </TimelineSeparator>
              <TimelineContent>
                <div>
                  <h6 className="mb-0 d-md-none">{item.date}</h6>
                  <span className="font-size-14 font-size-md-16">
                    {item.content}
                  </span>
                </div>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem className="timeline-separator">
              <TimelineOppositeContent className="timeline-year fw-bolder d-none d-md-flex" />
              <TimelineSeparator>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent />
            </TimelineItem>
          </Fragment>
        );
      })}

      <TimelineItem className="last-item-section">
        <TimelineOppositeContent className="d-none d-md-flex" />
        <TimelineSeparator>
          <NextIcon />
          <div className="d-none d-md-block">
            <h6 className="py-3 text-center">{tx["What next?"]}</h6>
            <p className="text-center">
              {tx[
                "With a team of [employees] and big plans, we’re excited for what's to come..."
              ].replace("[employees]", nEmp)}
            </p>
          </div>
        </TimelineSeparator>
        <TimelineContent>
          <div className="d-md-none px-3">
            <h6 className="mb-0">{tx["What next?"]}</h6>
            <p className="font-size-14 font-size-md-16">
              {tx[
                "With a team of [employees] and big plans, we’re excited for what's to come..."
              ].replace("[employees]", nEmp)}
            </p>
          </div>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};

export default TimelineSectionContent;
